let activity = [
  {
    path: '/activity_lose_weight',
    name: '减肥门诊',
    component: () => import('@/pages/activity/activity_lose_weight')
  },
  {
    path: '/activity_ask_doctor',
    name: '医生列表',
    component: () => import('@/pages/activity/activity_ask_doctor')
  },
  {
    path: '/anorectal_index',
    name: '肛肠专区',
    component: () => import('@/pages/activity/anorectal/anorectal_index')
  },
  {
    path: '/anorectal_operation',
    name: '肛肠名医手术预约',
    component: () => import('@/pages/activity/anorectal/anorectal_operation')
  },
  {
    path: '/anorectal_docList',
    name: '医生列表',
    component: () => import('@/pages/activity/anorectal/anorectal_docList')
  },
  {
    path: '/xinguan_precinct',
    name: '滇医通疫情医疗服务直通车',
    component: () => import('@/pages/activity/xinguan_precinct')
  },
  {
    path: '/xinguan_hospital_list',
    name: '核酸检测',
    component: () => import('@/pages/activity/xinguan_hospital_list')
  },
  {
    path: '/xinguan_doctor_list',
    name: '医生列表',
    component: () => import('@/pages/activity/xinguan_doctor_list')
  },
  {
    path: '/xinguan_common_diseases',
    name: '特色专区',
    component: () => import('@/pages/activity/xinguan_common_diseases')
  },
  {
    path: '/xinguan_report_list',
    name: '结果查询',
    component: () => import('@/pages/activity/xinguan_report_list')
  },
  {
    path: '/xinguan_report_query',
    name: '结果查询',
    component: () => import('@/pages/activity/xinguan_report_query')
  },
  {
    path: '/xinguan_report_pdf',
    name: '结果查询',
    component: () => import('@/pages/activity/xinguan_report_pdf')
  },
  {
    path: '/xinguan_visit_hospital',
    name: '核酸上门检测',
    component: () => import('@/pages/activity/xinguan_visit_hospital')
  },
  {
    path: '/xinguan_online_pay',
    name: '在线缴费',
    component: () => import('@/pages/activity/xinguan_online_pay')
  },
  {
    path: '/xinguan_qr',
    name: '结果查询',
    component: () => import('@/pages/activity/xinguan_qr')
  },
  {
    path: '/xinguan_time_period',
    name: '滇医通疫情医疗服务直通车',
    component: () => import('@/pages/activity/xinguan_time_period')
  },
  {
    path: '/soprt_medicine',
    name: '运动医学科',
    component: () => import('@/pages/activity/soprt_medicine')
    // component: () => import('@/pages/activity/soprt_medicine_new')
  },
  {
    path: '/soprt_medicine_new',
    name: '运动医学科',
    // component: () => import('@/pages/activity/soprt_medicine')
    component: () => import('@/pages/activity/soprt_medicine_new')
  },
  {
    path: '/xinguan_vaccine_list',
    name: '疫苗机构列表',
    component: () => import('@/pages/activity/xinguan_vaccine_list')
  },
  {
    path: '/sleep',
    name: '睡眠专区',
    component: () => import('@/pages/activity/sleep/sleep')
  },
  {
    path: '/sleep_test_list',
    name: '睡眠评测',
    component: () => import('@/pages/activity/sleep/sleep_test_list')
  },
  {
    path: '/sleep_question',
    name: '睡眠专区',
    component: () => import('@/pages/activity/sleep/sleep_question')
  },
  {
    path: '/sleep_detail',
    name: '睡眠专区',
    component: () => import('@/pages/activity/sleep/sleep_detail')
  },
  {
    path: '/sleep_my_test',
    name: '我的测评',
    component: () => import('@/pages/activity/sleep/sleep_my_test')
  },
  {
    path: '/sleep_test_detail',
    name: '测试结果',
    component: () => import('@/pages/activity/sleep/sleep_test_detail')
  },
  {
    path: '/sleep_registration_doc',
    name: '睡眠中心',
    component: () => import('@/pages/activity/sleep/sleep_registration_doc')
  },
  {
    path: '/sleep_registration_hospital',
    name: '选择医院',
    component: () => import('@/pages/activity/sleep/sleep_registration_hospital')
  },
  {
    path: '/sleep_test_result',
    name: '睡眠专区',
    component: () => import('@/pages/activity/sleep/sleep_test_result')
  },
  // {
  //   path: '/seats_order_confirm',
  //   name: '母婴健康公益活动报名',
  //   component: () => import('@/pages/activity/safetySeats/seats_order_confirm')
  // },
  // {
  //   path: '/seats_records_detail',
  //   name: '记录详情',
  //   component: () => import('@/pages/activity/safetySeats/seats_records_detail')
  // },
  // {
  //   path: '/seats_result_query',
  //   name: '结果查询',
  //   component: () => import('@/pages/activity/safetySeats/seats_result_query')
  // },
  // {
  //   path: '/seats_result',
  //   name: '领取结果',
  //   component: () => import('@/pages/activity/safetySeats/seats_result')
  // },
  {
    path: '/sleep_introduce',
    name: '睡眠专区',
    component: () => import('@/pages/activity/sleep/sleep_introduce')
  },
  {
    path: '/eye_health',
    name: '眼健康科普馆报名',
    component: () => import('@/pages/activity/eye_health/eye_health')
  },
  {
    path: '/eye_apply',
    name: '眼健康科普馆报名',
    component: () => import('@/pages/activity/eye_health/eye_apply')
  },
  {
    path: '/eye_detail',
    name: '订单详情',
    component: () => import('@/pages/activity/eye_health/eye_detail')
  },
  {
    path: '/eye_verification',
    name: '预约核验',
    component: () => import('@/pages/activity/eye_health/eye_verification')
  },
  {
    path: '/activity_free',
    name: '滇医通邀请三甲医院专家进社区活动',
    component: () => import('@/pages/activity/activity_free')
  },
  {
    path: '/article',
    name: '滇医通官方号',
    component: () => import('@/pages/activity/article')
  },
  {
    path: '/activity_page',
    name: '滇医通',
    component: () => import('@/pages/activity/activity_page')
  },
  {
    path: '/reproductive_area_index',
    name: '生殖专区',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_index')
  },
  {
    path: '/reproductive_area_index_new',
    name: '生殖专区',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_index_new')
  },
  {
    path: '/reproductive_area_list',
    name: '医生列表',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_list')
  },
  {
    path: '/reproductive_area_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_list_new')
  },
  {
    path: '/reproductive_area_consult',
    name: '生殖专区',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_consult')
  },
  {
    path: '/reproductive_area_active',
    name: '生殖专区',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_active')
  },
  {
    path: '/reproductive_area_intro',
    name: '生殖专区',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_intro')
  },
  {
    path: '/reproductive_area_hos',
    name: '生殖专区',
    component: () => import('@/pages/activity/reproductiveArea/reproductive_area_hos')
  },
  {
    path: '/neurosurgery_index',
    name: '神经外科专区',
    component: () => import('@/pages/activity/neurosurgery/neurosurgery_index')
  },
  {
    path: '/neurosurgery_index_new',
    name: '神经外科专区',
    component: () => import('@/pages/activity/neurosurgery/neurosurgery_index_new')
  },
  {
    path: '/hpv_area',
    name: '宫颈癌疫苗专区',
    component: () => import('@/pages/activity/hpv/hpv_area')
  },
  {
    path: '/hpv_doc_list',
    name: '宫颈癌疫苗专区',
    component: () => import('@/pages/activity/hpv/hpv_doc_list')
  },
  {
    path: '/gynecology',
    name: '妇科专区',
    component: () => import('@/pages/activity/gynecology/gynecology')
  },
  {
    path: '/gynecology_new',
    name: '妇科专区',
    component: () => import('@/pages/activity/gynecology/gynecology_new')
  },
  {
    path: '/gynecology_doc_list',
    name: '医生列表',
    component: () => import('@/pages/activity/gynecology/gynecology_doc_list')
  },
  {
    path: '/gynecology_doc_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/gynecology/gynecology_doc_list_new')
  },
  {
    path: '/sma_area',
    name: 'SMA专区',
    component: () => import('@/pages/activity/sma/sma_area')
  },
  {
    path: '/safeyear_area',
    name: '安全年服务专区',
    component: () => import('@/pages/activity/safeyear/safeyear_area')
  },
  {
    path: '/safeyear_registration',
    name: '安全年服务专区',
    component: () => import('@/pages/activity/safeyear/safeyear_registration')
  },
  {
    path: '/digestion',
    name: '消化内科专区',
    component: () => import('@/pages/activity/digestion/digestion')
    // component: () => import('@/pages/activity/digestion/digestion_new')
  },
  {
    path: '/digestion_new',
    name: '消化内科专区',
    // component: () => import('@/pages/activity/digestion/digestion')
    component: () => import('@/pages/activity/digestion/digestion_new')
  },
  {
    path: '/digestion_doc_list',
    name: '医生列表',
    component: () => import('@/pages/activity/digestion/digestion_doc_list')
  },
  {
    path: '/digestion_ask_doctor',
    name: '医生列表',
    component: () => import('@/pages/activity/digestion/digestion_ask_doctor')
  },
  {
    path: '/spine_index',
    name: '“脊管家”',
    component: () => import('@/pages/activity/spine/spine_index')
  },
  {
    path: '/spine',
    name: '“脊管家” 脊柱健康管理',
    component: () => import('@/pages/activity/spine/spine')
  },
  {
    path: '/spine_choose_patient',
    name: '选择测试人',
    component: () => import('@/pages/activity/spine/spine_choose_patient')
  },
  {
    path: '/spine_center',
    name: '个人中心',
    component: () => import('@/pages/activity/spine/spine_center')
  },
  {
    path: '/spine_test',
    name: '“脊管家” 脊柱健康管理',
    component: () => import('@/pages/activity/spine/spine_test')
  },
  {
    path: '/spine_detail',
    name: '“脊管家” 脊柱健康管理',
    component: () => import('@/pages/activity/spine/spine_detail')
  },
  {
    path: '/spine_question',
    name: '“脊管家” 脊柱健康管理',
    component: () => import('@/pages/activity/spine/spine_question')
  },
  {
    path: '/spine_test_list',
    name: '“脊管家” 脊柱健康管理',
    component: () => import('@/pages/activity/spine/spine_test_list')
  },
  {
    path: '/spine_test_detail',
    name: '测试结果',
    component: () => import('@/pages/activity/spine/spine_test_detail')
  },
  {
    path: '/spine_retest_detail',
    name: '测试结果',
    component: () => import('@/pages/activity/spine/spine_retest_detail')
  },
  {
    path: '/spine_team',
    name: '团队介绍',
    component: () => import('@/pages/activity/spine/spine_team')
  },
  {
    path: '/antigen_index',
    name: '抗原专区',
    component: () => import('@/pages/activity/antigen/antigen_index')
  },
  {
    path: '/antigen',
    name: '防疫专区',
    component: () => import('@/pages/activity/antigen/antigen')
  },
  {
    path: '/antigen_detail',
    name: '防疫专区',
    component: () => import('@/pages/activity/antigen/antigen_detail')
  },
  {
    path: '/antigen_order_detail',
    name: '防疫专区',
    component: () => import('@/pages/activity/antigen/antigen_order_detail')
  },
  {
    path: '/antigen_order',
    name: '防疫专区',
    component: () => import('@/pages/activity/antigen/antigen_order')
  },
  {
    path: '/antigen_order_list',
    name: '防疫专区',
    component: () => import('@/pages/activity/antigen/antigen_order_list')
  },
  {
    path: '/antigen_list',
    name: '防疫专区',
    component: () => import('@/pages/activity/antigen/antigen_list')
  },
  {
    path: '/antigen_apply',
    name: '抗原试剂预约',
    component: () => import('@/pages/activity/antigen/antigen_apply')
  },
  {
    path: '/antigen_registration',
    name: '呼吸科门诊挂号预约',
    component: () => import('@/pages/activity/antigen/antigen_registration')
  },
  {
    path: '/antigen_registration_dept',
    name: '呼吸科门诊挂号预约',
    component: () => import('@/pages/activity/antigen/antigen_registration_dept')
  },
  {
    path: '/nucleic_acid_testing',
    name: '核酸检测预约',
    component: () => import('@/pages/activity/antigen/nucleic_acid_testing')
  },
  {
    path: '/nucleic_acid_hos',
    name: '核酸采样点检测预约',
    component: () => import('@/pages/activity/antigen/nucleic_acid_hos')
  },
  {
    path: '/kunhua_satisfaction',
    name: '满意度调查',
    component: () => import('@/pages/activity/kunhua_satisfaction')
  },
  {
    path: '/skin_index',
    name: '皮肤科专区',
    component: () => import('@/pages/activity/skin/skin_index')
    // component: () => import('@/pages/activity/skin/skin_index_new')
  },
  {
    path: '/skin_index_new',
    name: '皮肤科专区',
    // component: () => import('@/pages/activity/skin/skin_index')
    component: () => import('@/pages/activity/skin/skin_index_new')
  },
  {
    // path: '/skin_doc_list',
    path: '/skin_doc_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/skin/skin_doc_list_new')
  },
  {
    path: '/skin_doc_list',
    // path: '/skin_doc_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/skin/skin_doc_list')
  },
  {
    path: '/yunpi_doc_list',
    name: '医生列表',
    component: () => import('@/pages/activity/yunpi/yunpi_doc_list')
  },
  {
    path: '/yunpi_doc_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/yunpi/yunpi_doc_list_new')
  },
  {
    path: '/maliya_specialist',
    name: '专家门诊',
    component: () => import('@/pages/activity/maliya/maliya_specialist')
  },
  {
    path: '/maliya_specialist_new',
    name: '专家门诊',
    component: () => import('@/pages/activity/maliya/maliya_specialist_new')
  },
  {
    path: '/maliya_early_pregnancy',
    name: '早孕门诊',
    component: () => import('@/pages/activity/maliya/maliya_early_pregnancy')
  },
  {
    path: '/maliya_early_pregnancy_new',
    name: '早孕门诊',
    component: () => import('@/pages/activity/maliya/maliya_early_pregnancy_new')
  },
  {
    path: '/cardiology_index',
    name: '心律失常专区',
    component: () => import('@/pages/activity/cardiology/cardiology_index')
  },
  {
    path: '/cardiology_index_new',
    name: '心律失常专区',
    component: () => import('@/pages/activity/cardiology/cardiology_index_new')
  },
  {
    path: '/cardiology_doc_list',
    name: '医生列表',
    component: () => import('@/pages/activity/cardiology/cardiology_doc_list')
  },
  {
    path: '/cardiology_doc_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/cardiology/cardiology_doc_list_new')
  },
  {
    path: '/maliya_pregnancy_screening',
    name: '孕期筛查门诊',
    component: () => import('@/pages/activity/maliya/maliya_pregnancy_screening')
  },
  {
    path: '/maliya_tocolyis_case',
    name: '保胎案例',
    component: () => import('@/pages/activity/maliya/maliya_tocolyis_case')
  },
  {
    path: '/maliya_tocolyis_case_new',
    name: '保胎案例',
    component: () => import('@/pages/activity/maliya/maliya_tocolyis_case_new')
  },
  {
    path: '/maliya_operation',
    name: '妇科手术',
    component: () => import('@/pages/activity/maliya/maliya_operation')
  },
  {
    path: '/maliya_confinement',
    name: '月子中心',
    component: () => import('@/pages/activity/maliya/maliya_confinement')
  },
  {
    path: '/maliya_case_detail',
    name: '案例详情',
    component: () => import('@/pages/activity/maliya/maliya_case_detail')
  },
  {
    path: '/maliya_infertility',
    name: '不孕不育',
    component: () => import('@/pages/activity/maliya/maliya_infertility')
  },
  {
    path: '/maliya_infertility_new',
    name: '不孕不育',
    component: () => import('@/pages/activity/maliya/maliya_infertility_new')
  },
  {
    path: '/heredity_index',
    name: '医学遗传专区',
    component: () => import('@/pages/activity/heredity/heredity_index')
  },
  {
    path: '/heredity_index_new',
    name: '医学遗传专区',
    component: () => import('@/pages/activity/heredity/heredity_index_new')
  },
  {
    path: '/heredity_doc_list',
    name: '医生列表',
    component: () => import('@/pages/activity/heredity/heredity_doc_list')
  },
  {
    path: '/heredity_doc_list_new',
    name: '医生列表',
    component: () => import('@/pages/activity/heredity/heredity_doc_list_new')
  },
  {
    path: '/heredity_info',
    name: '医学遗传科',
    component: () => import('@/pages/activity/heredity/heredity_info')
  },
  {
    path: '/shengsan_gynecology',
    name: '妇科微创专区',
    component: () => import('@/pages/activity/gynecology/shengsan_gynecology')
  },
  {
    path: '/shengsan_gynecology_new',
    name: '妇科微创专区',
    component: () => import('@/pages/activity/gynecology/shengsan_gynecology_new')
  },
  {
    path: '/shengsan_type',
    name: '专病治疗',
    component: () => import('@/pages/activity/gynecology/shengsan_type')
  },
  {
    path: '/shengsan_type_new',
    name: '专病治疗',
    component: () => import('@/pages/activity/gynecology/shengsan_type_new')
  },
  {
    path: '/gynecology_operation',
    name: '妇科手术',
    component: () => import('@/pages/activity/gynecology/gynecology_operation')
  },
  {
    path: '/orthopedics',
    name: '骨科专区',
    component: () => import('@/pages/activity/orthopedics/index')
  },
  {
    path: '/orthopedics_new',
    name: '骨科专区',
    component: () => import('@/pages/activity/orthopedics_new/index')
  },
  {
    path: '/class_list',
    name: '好孕案例',
    component: () => import('@/pages/activity/songziniao/class_list')
  },
  {
    path: '/cough',
    name: '咳嗽专区',
    component: () => import('@/pages/activity/cough/index')
  },
  {
    path: '/cough_new',
    name: '咳嗽专区',
    component: () => import('@/pages/activity/cough_new/index')
  },
  {
    path: '/medicine',
    name: '一键购药',
    component: () => import('@/pages/activity/medicine/index')
  },
  {
    path: '/before_medicine',
    name: '一键购药',
    component: () => import('@/pages/activity/medicine/before')
  },

  {
    path: '/epilepsy',
    name: '癫痫专区',
    component: () => import('@/pages/activity/epilepsy/index')
  },
  {
    path: '/epilepsy_new',
    name: '癫痫专区',
    component: () => import('@/pages/activity/epilepsy_new/index')
  },
  {
    path: '/kunpi_start',
    name: '明星制剂',
    component: () => import('@/pages/activity/kunpi_start')
  },
  {
    path: '/athome_ask',
    name: '疫情居家咨询',
    component: () => import('@/pages/activity/athome_ask')
  },
  {
    path: '/mdt_diagnosis',
    name: '多学科诊疗',
    component: () => import('@/pages/activity/mdt_diagnosis_new')
  },
  {
    path: '/wcj_reg',
    name: '胃肠镜预约',
    component: () => import('@/pages/activity/wcj_reg')
  },
  {
    path: '/surgery_appoint',
    name: '手术预约',
    component: () => import('@/pages/activity/surgery/index')
  },
  {
    path: '/surgery_config',
    name: '预约结果',
    component: () => import('@/pages/activity/surgery/config')
  },
  {
    path: '/influenza',
    name: '流感检测',
    component: () => import('@/pages/activity/influenza')
  },
  {
    path: '/active_qcode',
    name: '体检报告查询',
    component: () => import('@/pages/activity/active_qcode')
  },
  {
    path: '/day_surgery',
    name: '日间手术',
    component: () => import('@/pages/activity/surgery/day_surgery')
  }
]

export default activity
